import { Link } from "react-router-dom";
import { fileUrl } from "../lib/api";
import { Tag } from "lucide-react";

const HORSE_PLACEHOLDER = "https://images.pexels.com/photos/32076745/pexels-photo-32076745.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const HorseCard = ({ horse }) => {
  const photo = horse.photo_path ? fileUrl(horse.photo_path) : HORSE_PLACEHOLDER;
  const female = horse.gender === "Гүү" || horse.gender === "Үрээ";
  return (
    <Link
      to={`/horse/${horse.id}`}
      className="group bg-white border border-[#D6CFC4] hover:border-[#B8860B] rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 flex flex-col"
      data-testid={`horse-card-${horse.id}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[#F0EBE1]">
        <img src={photo} alt={horse.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        {horse.gender && (
          <span className={`absolute top-2 left-2 px-2 py-0.5 rounded text-[10px] font-bold uppercase ${female ? "bg-[#8B2500] text-white" : "bg-[#1B3B5A] text-white"}`}>
            {horse.gender}
          </span>
        )}
        {horse.is_for_sale && (
          <span className="absolute top-2 right-2 inline-flex items-center gap-1 bg-[#B8860B] text-white px-2 py-0.5 rounded text-[10px] font-bold uppercase">
            <Tag size={10} /> Зар
          </span>
        )}
      </div>
      <div className="p-4 flex-1 flex flex-col">
        <h3 className="text-lg font-bold text-[#1B3B5A] group-hover:text-[#B8860B] transition-colors leading-tight">
          {horse.name}
        </h3>
        <div className="text-xs text-[#5C4F42] mt-0.5">
          {[horse.color, horse.birth_year && `${horse.birth_year} он`].filter(Boolean).join(" · ")}
        </div>
        <div className="mt-3 text-xs text-[#2C241B] space-y-1">
          {horse.registration_number && (
            <div><span className="text-[#5C4F42]">Бүртгэл:</span> <span className="font-semibold">{horse.registration_number}</span></div>
          )}
          {horse.microchip && (
            <div><span className="text-[#5C4F42]">Микрочип:</span> <span className="font-mono">{horse.microchip}</span></div>
          )}
          {horse.country && (
            <div><span className="text-[#5C4F42]">Улс:</span> {horse.country}</div>
          )}
          {horse.owner_name && (
            <div className="pt-2 border-t border-[#E5DFD3] mt-2">
              <span className="text-[#5C4F42]">Эзэмшигч:</span> {horse.owner_name}
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default HorseCard;
